export function off<T extends Window | Document | HTMLElement | EventTarget>(
  obj: T | null,
  ...args:
    | Parameters<T['removeEventListener']>
    | [string, Function | null, ...any]
): void {
  if (obj && obj.removeEventListener) {
    obj.removeEventListener(
      ...(args as Parameters<HTMLElement['removeEventListener']>)
    )
  }
}

if (import.meta.vitest) {
  const { describe, expect, it, vi } = import.meta.vitest

  describe('off', () => {
    it('removes the event listener from target', () => {
      const target = new EventTarget()
      const handler = vi.fn()

      target.addEventListener('click', handler)
      off(target, 'click', handler)
      target.dispatchEvent(new Event('click'))

      expect(handler).not.toHaveBeenCalled()
    })

    it('does nothing for null targets', () => {
      expect(() => off(null, 'click', () => {})).not.toThrow()
    })
  })
}
